import Call from '../Call';

const BidderSources = {
    get() {
        return Call(`bidderSources`);
    },

    getAvailableSources() {
        return Call(`bidderSources/sources`);
    },

    getAvailableSourcesObj() {
        return Call(`bidderSources/sources/obj`);
    },

    getTypes() {
        return Call(`bidderSources/types`);
    },

    save(source) {
        return Call('bidderSources','POST', source);
    },

    update(id, source) {
        return Call(`bidderSources/${id}`,'PUT', source);
    },

    remove(id) {
        return Call(`bidderSources/${id}`,'DELETE');
    }
};

export default BidderSources;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderSources.js